import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import TicketForm from './TicketForm';

const AddSupportTicket = observer(class AddSupportTicket extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="wrap block-form">
          <TicketForm {...this.props} newTicket={true} />
        </div>
      </div>
    )
  }
})

export default translate('AddSupportTicket')(AddSupportTicket);


// WEBPACK FOOTER //
// ./src/app/components/SupportTickets/AddSupportTicket.js